import cn from 'classnames';
import styles from './EventsBlock.module.scss';
import { EventType } from '@/types';
import { EventCard } from '../EventCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import { SwiperButton } from '../SliderBlock';
import { useTranslations } from '@/hooks/useTranslations';
import { parseText } from '@/utils/parseText';
import { useAdaptiveWidth } from '@/hooks/useAdaptiveWidth';

type EventsBlockProps = {
  events: EventType[];
  className?: string;
  code: string;
};

export function EventsBlock({ events, code, className }: EventsBlockProps) {
  const { isTablet } = useAdaptiveWidth();
  const showButtons = events.length > 4;
  const translations = useTranslations();

  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <Swiper
      slidesPerView="auto"
      spaceBetween={16}
      className={wrapperClassName}
      freeMode
      modules={[FreeMode]}
    >
      <div className={styles.header}>
        <h3 className={cn(styles.title, 'custom-events-title')}>
          {parseText(translations.events)}
        </h3>
        {!isTablet && showButtons && (
          <div className={styles.buttons}>
            <SwiperButton />
            <SwiperButton isNextButton />
          </div>
        )}
      </div>
      {events.map((event, index) => (
        <SwiperSlide key={`${event.name}-${index}`} className="custom-slide">
          <EventCard
            key={event.code + index}
            tag={event.tag}
            title={event.name}
            description={event.text}
            button={event.button}
            dateFrom={event.dateFrom}
            dateTo={event.dateTo}
            buttonLink={event.buttonLink}
            dateText={event.dateText}
            info={`${event.timeFrom ? event.timeFrom : ''}${
              event.timeTo ? '-' + event.timeTo : ''
            }`}
            parentEvent={code}
            closed={event.closed}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
